import { defineMessages } from 'react-intl';

const messages = defineMessages({
  showSocialShare: {
    id: 'News listing show social share',
    defaultMessage: 'Mostrar botons de compartir a xarxes socials',
  },
});

export const newsListingSchemaEnhancer = ({ schema, intl }) => {
  if (!schema.fieldsets?.[0]?.fields.includes('showSocialShare')) {
    schema.fieldsets[0].fields.push('showSocialShare');
  }

  schema.properties.showSocialShare = {
    title: intl.formatMessage(messages.showSocialShare),
    type: 'boolean',
    default: true,
  };

  return schema;
};
